import type { ReactNode } from 'react';

import Link from '~/components/Link';

type PillTone = 'dark' | 'forest';

const PILL_CLASSES =
  'flex h-10 min-w-[5rem] shrink-0 items-center justify-center gap-2 whitespace-nowrap rounded-full px-4 text-center text-xs transition duration-200 ease-in-out active:scale-95';

export function pillClassName({
  active,
  tone = 'dark'
}: {
  active?: boolean;
  tone?: PillTone;
}) {
  if (!active)
    return `${PILL_CLASSES} border border-grey-divide text-grey-hide`;

  return `${PILL_CLASSES} ${tone === 'forest' ? 'bg-forest' : 'bg-black'} text-white`;
}

type Props = {
  active?: boolean;
  children: ReactNode;
  onClick?: () => void;
  rel?: string;
  to: string;
};

export default function Pill({ active, children, onClick, rel, to }: Props) {
  return (
    <Link
      className={pillClassName({ active })}
      onClick={onClick}
      rel={rel}
      to={to}
    >
      {children}
    </Link>
  );
}
